<template>
  <div v-if="!settings.newLayout" class="container-center mb-5 flex flex-col overflow-x-auto">
    <nav ref="navigation" class="mb-2 flex">
      <router-link
        v-for="(item, key) in itens"
        :key="key"
        :to="item.to || ''"
        class="navlink inline-flex items-center gap-2 px-4 py-2 text-center text-sm text-black hover:text-neutral-900 dark:hover:text-neutral-500 no-underline dark:text-neutral-300"
        :class="{ active: active === key }"
        @click="select(key)"
      >
        <UiIcon
          v-if="item.icon"
          :size="24"
          :icon="item.icon.name"
        />
        {{ item.nome }}
      </router-link>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useSessionStorage } from '@vueuse/core'
import UiIcon from '@/components/ui/icon.vue'

const settings = useSessionStorage('sys-settings', {
  newLayout: true,
  demoGamification: false
})

interface Item {
  nome?: string
  icon?: {
    name?: string
  }
  to?: string
  redirect?: string
}

const props = defineProps<{
  itens?: Item[]
}>()

const router = useRouter()

// Referência aos elementos do templates
const navigation = ref(null)
const active = ref(null)

/**
 * Evento selecionar elemento
 * @param event
 */
const select = (index) => {
  props.itens[index].redirect 
    ? window.open(props.itens[index].redirect, '_blank')
    : active.value = index
}

/**
 * Execução ao montar elemento
 */
onMounted(() => {
  const idx = props.itens.findIndex((c) => c.to === router.currentRoute.value.path)

  // "Clica" automaticamente no elemento do menu correspondente á rota atual
  if (idx > -1) {
    navigation.value?.querySelectorAll('.navlink')[idx].click()
  }
})
</script>

<style lang="scss" scoped>
.navlink {
  border-bottom: 2px solid transparent;
  text-shadow: 0 0 0 rgba($color: #000, $alpha: 0);
  transition: all 0.2s ease-in-out;
  transform: translateY(0);

  &:hover:not(&.active) {
    text-shadow: 2px 2px 2px rgba($color: #000, $alpha: 0.2);
  }

  &:hover,
  &.active {
    transform: translateY(-2px) scale(1.1);
  }
}
.navlink {
  border: none;
  position: relative;

  &::after {
    @apply bg-neutral-700 dark:bg-neutral-500 rounded;
    content: '';
    position: absolute;
    width: 0px;
    height: 2px;
    left: 50%;
    bottom: 0;
    transition: all ease-in-out 0.2s;
  }

  &:hover::after {
    left: 25%;
    width: 50%;
  }
  
  &.active::after {
    @apply bg-current;
    width: 100%;
    left: 0;
  }
}
</style>
